export var EBannerRowSize = /* @__PURE__ */ ((EBannerRowSize2) => {
  EBannerRowSize2["Large"] = "Large";
  EBannerRowSize2["Medium"] = "Medium";
  EBannerRowSize2["Small"] = "Small";
  return EBannerRowSize2;
})(EBannerRowSize || {});
export var EBannersMobileHeight = /* @__PURE__ */ ((EBannersMobileHeight2) => {
  EBannersMobileHeight2["LARGE"] = "LARGE";
  EBannersMobileHeight2["MEDIUM"] = "MEDIUM";
  EBannersMobileHeight2["SMALL"] = "SMALL";
  return EBannersMobileHeight2;
})(EBannersMobileHeight || {});
export var EBannerSize = /* @__PURE__ */ ((EBannerSize2) => {
  EBannerSize2["Large"] = "Large";
  EBannerSize2["Medium"] = "Medium";
  EBannerSize2["Small"] = "Small";
  EBannerSize2["Hug"] = "Hug";
  return EBannerSize2;
})(EBannerSize || {});
export var EImagePosition = /* @__PURE__ */ ((EImagePosition2) => {
  EImagePosition2["right"] = "right";
  EImagePosition2["bottom"] = "bottom";
  return EImagePosition2;
})(EImagePosition || {});
export var ETitleSizes = /* @__PURE__ */ ((ETitleSizes2) => {
  ETitleSizes2["DISPLAY_MD"] = "display-md";
  ETitleSizes2["DISPLAY_SM"] = "display-sm";
  ETitleSizes2["DISPLAY_XS"] = "display-xs";
  ETitleSizes2["DISPLAY_XS_SMALLER"] = "display-xs-smaller";
  ETitleSizes2["DISPLAY_2XS"] = "display-2xs";
  return ETitleSizes2;
})(ETitleSizes || {});
export var EMobileOrientation = /* @__PURE__ */ ((EMobileOrientation2) => {
  EMobileOrientation2["STACK"] = "stack";
  EMobileOrientation2["SWIPE"] = "swipe";
  return EMobileOrientation2;
})(EMobileOrientation || {});
export var ESeoHeadingSize = /* @__PURE__ */ ((ESeoHeadingSize2) => {
  ESeoHeadingSize2["H1"] = "h1";
  ESeoHeadingSize2["H2"] = "h2";
  ESeoHeadingSize2["H3"] = "h3";
  ESeoHeadingSize2["H4"] = "h4";
  return ESeoHeadingSize2;
})(ESeoHeadingSize || {});
